const AppComponentKey = {
    // 数据列表
    Grid: 'Grid',
    // 树形数据源
    Tree: 'Tree',
    // 网页
    WebSite: 'WebSite',
    // 树形菜单
    TreeMenu: 'TreeMenu',
    // 文件列表
    FileGrid: 'FileGrid',
    // 外部数据源列表
    ExDatasource: 'ExDatasource',
    // 报表
    Report: 'Report',
    //邮件
    MailGrid: 'MailGrid',
};

export default AppComponentKey;
